import {
  Add_Lead_Assigned_Type,
  Get_All_Lead_Assigned_Type,
  Get_All_Leads_Selected_TO_Assign_Type,
  Get_Error,
  Get_One_Lead_Assigned_Type,
  Update_One_Lead_Assigned_Type,
} from '../Types';
import usedeletedata from '../../Hooks/useDeleteData';
import usegetdata from '../../Hooks/useGetData';
import { useinsertdatawithoutimage } from '../../Hooks/usePostData';
import { UpdateProductdata } from '../../Hooks/useUpdateData';
export const Insert_Lead_Assigned_Data_Action = (body) => async (dispatch) => {
  try {
    const res = await useinsertdatawithoutimage(`/api/v1/LeadAssigned`, body);

    dispatch({
      type: Add_Lead_Assigned_Type,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

//get all Lead Assigned

export const Get_All_Lead_Assigned_Data_Action = (leadid) => async (dispatch) => {
  try {
    const res = await usegetdata(`/api/v1/LeadAssigned?LeadId=${leadid}`);

    dispatch({
      type: Get_All_Lead_Assigned_Type,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

export const Get_All_Lead_Selected_To_Assign_Action = (leadIdsArray) => async (dispatch) => {
  try {
    const res = await useinsertdatawithoutimage(`api/v1/LeadAssigned/get-assigned-by-leads`, {
      leadIds: leadIdsArray, // ✅ أرسل كـ leadIds
    });

    dispatch({
      type: Get_All_Leads_Selected_TO_Assign_Type,
      payload: res,
    });

    return res;
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.response?.data || { message: 'Unknown error' },
    });
  }
};

//=============================================================
//get one Lead Assigned data
//get all Lead Assigned

export const Get_One_Lead_Assigned_Data_Action = (id) => async (dispatch) => {
  try {
    const res = await usegetdata(`/api/v1/LeadAssigned/${id}`);

    dispatch({
      type: Get_One_Lead_Assigned_Type,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

//==========================================================

//update one Lead Assigned data
export const Update_one_Lead_Assigned_Data_Action = (id, body) => async (dispatch) => {
  try {
    const res = await UpdateProductdata(`/api/v1/LeadAssigned/${id}`, body);

    dispatch({
      type: Update_One_Lead_Assigned_Type,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

//delete one Lead Assigned action
export const Delete_one_Lead_Assigned_Data_Action = (id) => async (dispatch) => {
  try {
    const res = await usedeletedata(`/api/v1/LeadAssigned/${id}`);

    dispatch({
      type: Delete_one_Lead_Assigned_Data_Action,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};
